import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AppState } from "../../../context/stores/rootReducers";
import { useEffect } from "react";
import { actions } from "../../../context/stores/rootActions";
import { eBaseActionStatus } from "../../../context/base/eBaseActionStatus";

export function useLookupProductType() {
	const dispatch = useDispatch();
	const { status, allProductTypes } = useSelector((state: AppState) => state.productType);
	useEffect(() => {
		if (status === eBaseActionStatus.idle || status === eBaseActionStatus.reload) dispatch(actions.productType.getAllRequest());
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return { product_type_all: allProductTypes };
}
